const getRequest = async (endpoint: string, token: string) => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: {
        'Authorization': `Bearer ${token}`
      },
    };
  
    try {
      const response = await fetch(endpoint, { ...requestOptions, redirect: "follow" as RequestRedirect });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error making GET request:', error);
      throw error;
    }
  };


  export { getRequest };